// extracted by mini-css-extract-plugin
module.exports = {"list-card":"List_list-card__3ViGl","body-container":"List_body-container__2kDie","button-container":"List_button-container__2WeZQ","delete-button":"List_delete-button__3z1RG"};